import dayjs from "dayjs";

export const borrarObjetosDuplicados = (arrayOriginal, prop, soloPropiedad) => {
  var arrayNuevo = [];
  var arrayFiltrable = [];

  for (var i in arrayOriginal) {
    //@ts-ignore
    arrayFiltrable[arrayOriginal[i][prop]] = arrayOriginal[i];
  }

  for (i in arrayFiltrable) {
    if (soloPropiedad) {
      arrayNuevo.push(arrayFiltrable[i][prop]);
    } else {
      arrayNuevo.push(arrayFiltrable[i]);
    }
  }
  return arrayNuevo;
};

export const ordenarArrayObjetosByDate = (arrayOriginal, propDate) => {
  return arrayOriginal.sort((n1, n2) => dayjs(n1[propDate]).unix() - dayjs(n2[propDate]).unix());
};

export const ordenarArrayObjetosByNumber = (arrayOriginal, prop) => {
  return arrayOriginal.sort((n1, n2) => n1[prop] - n2[prop]);
};

export const obtenerIndiceArrayFechasTurnos = (array, fechaSeleccionada) => {
  const fechaActual = dayjs(dayjs().format("YYYY-MM-DD"));
  let indiceRetornar = -1;
  if (fechaSeleccionada !== undefined) {
    array.forEach((fecha, i) => {
      if (fecha.codigo === fechaSeleccionada?.codigo) indiceRetornar = i;
    });
  }

  if (indiceRetornar === -1) {
    indiceRetornar = array.reduce((indiceMasCercano, fecha, currentIndex) => {
      const distanciaActual = Math.abs(fecha.codigo - fechaActual.unix());
      const distanciaMasCercana = Math.abs(array[indiceMasCercano].codigo - fechaActual.unix());

      if (distanciaActual < distanciaMasCercana) {
        return currentIndex;
      } else {
        return indiceMasCercano;
      }
    }, 0);

    if (array[indiceRetornar].codigo < fechaActual.unix() && array.length - 1 > indiceRetornar)
      indiceRetornar++;
  }

  return indiceRetornar;
};
